var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link",
    transform: "translate(-5023 1224.641)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3041",
    "data-name": "Rectangle 3041",
    width: 20,
    height: 20,
    transform: "translate(5023 -1224.641)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "link-svgrepo-com",
    d: "M9.7,12.7a.893.893,0,0,0,0-1.264,2.51,2.51,0,0,1,0-3.55L12.7,4.876a2.51,2.51,0,1,1,3.55,3.55l-.93.929a.894.894,0,0,0,1.264,1.264l.93-.929a4.3,4.3,0,1,0-6.077-6.077L8.432,6.621a4.3,4.3,0,0,0,0,6.077.894.894,0,0,0,1.264,0ZM11.44,8.426a.893.893,0,0,0,0,1.264,2.51,2.51,0,0,1,0,3.55L8.462,16.218a2.51,2.51,0,1,1-3.549-3.55l.872-.872a.894.894,0,1,0-1.264-1.264L3.65,11.4a4.3,4.3,0,0,0,6.077,6.077L12.705,14.5a4.3,4.3,0,0,0,0-6.077.893.893,0,0,0-1.264,0Z",
    transform: "translate(5022.109 -1225.495)",
    fill: "#5773d1",
    stroke: "#fff",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleLink);
export default __webpack_public_path__ + "static/media/purpleLink.c3caff5b07c3cc4185e56db158877736.svg";
export { ForwardRef as ReactComponent };